import React, { useEffect, useRef, useState } from "react";
import "./LudoManiaHero.css";

const C = {
  green:      "#639922",
  greenLight: "#83c43a",
  purple:     "#7f77dd",
  pink:       "#d4537e",
  teal:       "#1d9e75",
  amber:      "#ef9f27",
};

const GAME_MODES = [
  {
    players: 4,
    name: "Classic Ludo",
    tag: "Most Popular",
    desc: "The timeless 4-player format. Perfect for families and quick matches with friends.",
    colors: ["#639922", "#7f77dd", "#d4537e", "#ef9f27"],
  },
  {
    players: 6,
    name: "Extended Play",
    tag: "Team Mode",
    desc: "6 players on a bigger board — more strategy, more chaos, more fun.",
    colors: ["#639922", "#7f77dd", "#d4537e", "#ef9f27", "#1d9e75", "#e53e3e"],
  },
  {
    players: 8,
    name: "Tournament Mode",
    tag: "Epic",
    desc: "8-player ultimate showdown. Pure skill and strategy on the grandest board.",
    colors: ["#639922", "#7f77dd", "#d4537e", "#ef9f27", "#1d9e75", "#e53e3e", "#3182ce", "#dd6b20"],
  },
];

const STEPS = [
  { n: "01", icon: "🎲", title: "Roll the Dice",      desc: "Click the 3D dice. Roll a 6 to bring a piece out of your home base." },
  { n: "02", icon: "♟",  title: "Move a Piece",       desc: "Tap any glowing piece to advance it by your dice value." },
  { n: "03", icon: "⚔️", title: "Capture Opponents",  desc: "Land on an enemy piece to send it back to their starting base." },
  { n: "04", icon: "🏆", title: "Win the Game",       desc: "First player to get all 4 pieces to the center column wins!" },
];

const SOCIAL = [
  {
    name: "X (Twitter)", href: "#",
    icon: <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.451-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>,
  },
  {
    name: "Instagram", href: "#",
    icon: <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>,
  },
  {
    name: "Discord", href: "#",
    icon: <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/></svg>,
  },
  {
    name: "YouTube", href: "#",
    icon: <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>,
  },
];

const FEATURES = [
  { icon: "👥", title: "Multiplayer rooms",  desc: "Share a code, friends join instantly" },
  { icon: "🤖", title: "AI opponents",       desc: "Smart bots that never keep you waiting" },
  { icon: "🎲", title: "3D dice physics",    desc: "Realistic rolls powered by WebGL" },
  { icon: "⚡", title: "Zero setup",         desc: "Open browser and play — no account" },
];

const STATS = [
  { val: "2–8",  lbl: "Players" },
  { val: "3D",   lbl: "Dice"    },
  { val: "Free", lbl: "Forever" },
  { val: "AI",   lbl: "Bots"    },
];

/* ---- Mini board SVG for carousel ---- */
function MiniBoard({ players, colors }) {
  const size = 190;
  const cx = size / 2;
  const cy = size / 2;
  const outerR = 80;
  const innerR = 30;

  const polar = (r, angleDeg) => ({
    x: cx + r * Math.cos((angleDeg * Math.PI) / 180),
    y: cy + r * Math.sin((angleDeg * Math.PI) / 180),
  });

  const sectors = colors.map((color, i) => {
    const a1 = (i / players) * 360 - 90;
    const a2 = ((i + 1) / players) * 360 - 90;
    const o1 = polar(outerR, a1);
    const o2 = polar(outerR, a2);
    const i1 = polar(innerR, a1);
    const i2 = polar(innerR, a2);
    const large = a2 - a1 > 180 ? 1 : 0;
    const d = `M${i1.x},${i1.y} L${o1.x},${o1.y} A${outerR},${outerR} 0 ${large},1 ${o2.x},${o2.y} L${i2.x},${i2.y} A${innerR},${innerR} 0 ${large},0 ${i1.x},${i1.y}Z`;
    const mid = polar((outerR + innerR) / 2, (a1 + a2) / 2);
    return { d, color, mid };
  });

  return (
    <svg viewBox={`0 0 ${size} ${size}`} className="lm-mini-board">
      <circle cx={cx} cy={cy} r={outerR + 8} fill="#0d0d1a" />
      {sectors.map((s, i) => (
        <g key={i}>
          <path d={s.d} fill={s.color} opacity={0.78} stroke="#0a0a12" strokeWidth="2" />
          <circle cx={s.mid.x} cy={s.mid.y} r={9} fill={s.color} stroke="rgba(255,255,255,0.28)" strokeWidth="1.5" />
        </g>
      ))}
      <circle cx={cx} cy={cy} r={innerR - 2} fill="#1a1a2e" />
      <text x={cx} y={cy + 7} textAnchor="middle" fontSize="20" fill="#facc15">★</text>
    </svg>
  );
}

/* ---- Existing hero board ---- */
function BoardSVG() {
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="lm-board-svg">
      <defs>
        <clipPath id="boardClip">
          <polygon points="100,4 196,52 196,148 100,196 4,148 4,52" />
        </clipPath>
      </defs>
      <polygon points="100,4 196,52 196,148 100,196 4,148 4,52" fill="#13131f" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
      <g clipPath="url(#boardClip)">
        <polygon points="100,4 160,36 130,70 70,70 40,36"           fill="#162210" stroke="rgba(99,153,34,0.25)"   strokeWidth="0.5" />
        <polygon points="196,52 196,148 155,130 130,115 130,85 155,70" fill="#16102a" stroke="rgba(127,119,221,0.25)" strokeWidth="0.5" />
        <polygon points="100,196 40,164 70,130 130,130 160,164"       fill="#2a1020" stroke="rgba(212,83,126,0.25)"  strokeWidth="0.5" />
        <polygon points="4,52 45,70 70,85 70,115 45,130 4,148"        fill="#0e2420" stroke="rgba(29,158,117,0.25)"  strokeWidth="0.5" />
        <polygon points="100,70 130,85 130,115 100,130 70,115 70,85" fill="#1a1a2e" stroke="rgba(255,255,255,0.06)" strokeWidth="0.5" />
        <polygon points="100,75 125,88 100,100"  fill={C.green}  opacity="0.9" />
        <polygon points="125,88 125,112 100,100" fill={C.purple} opacity="0.9" />
        <polygon points="100,125 125,112 100,100" fill={C.pink}  opacity="0.9" />
        <polygon points="75,112 100,125 100,100" fill={C.teal}   opacity="0.9" />
        <polygon points="75,88 100,75 100,100"   fill={C.amber}  opacity="0.85" />
        <g fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="0.5">
          <line x1="85" y1="70" x2="85" y2="130" />
          <line x1="115" y1="70" x2="115" y2="130" />
          <line x1="70" y1="85" x2="130" y2="85" />
          <line x1="70" y1="115" x2="130" y2="115" />
        </g>
        {[
          { cx: 68,  cy: 44,  c: C.teal   },
          { cx: 88,  cy: 36,  c: C.green  },
          { cx: 112, cy: 36,  c: C.green  },
          { cx: 132, cy: 44,  c: C.purple },
          { cx: 156, cy: 96,  c: C.purple },
          { cx: 156, cy: 116, c: C.pink   },
          { cx: 132, cy: 156, c: C.pink   },
          { cx: 112, cy: 164, c: C.teal   },
          { cx: 88,  cy: 164, c: C.teal   },
          { cx: 68,  cy: 156, c: C.green  },
          { cx: 44,  cy: 116, c: C.green  },
          { cx: 44,  cy: 96,  c: C.teal   },
        ].map((d, i) => (
          <circle key={i} cx={d.cx} cy={d.cy} r={9} fill={d.c} opacity={0.75} stroke="rgba(255,255,255,0.12)" strokeWidth="0.5" />
        ))}
        {[[100,62],[55,102],[145,102],[100,142]].map(([x,y],i) => (
          <text key={i} x={x} y={y} textAnchor="middle" fontSize="10" fill={C.amber} opacity="0.85">★</text>
        ))}
      </g>
    </svg>
  );
}

const CHIPS = [
  { color: C.green,  style: { top: "21%", left: "43%" } },
  { color: C.purple, style: { top: "34%", right: "13%" } },
  { color: C.pink,   style: { bottom: "19%", left: "51%" } },
  { color: C.teal,   style: { top: "50%", left: "11%" } },
];

export default function LudoManiaHero({ onPlayClick, onRoomClick, onPlayWithBots, onWatchClick, onNearbyClick }) {
  const [visible, setVisible] = useState(false);
  const [activeMode, setActiveMode] = useState(0);
  const floatRef = useRef(null);

  useEffect(() => {
    setVisible(true);
    let y = 0, dir = 1, raf;
    function tick() {
      y += 0.04 * dir;
      if (y > 8) dir = -1;
      if (y < 0) dir = 1;
      if (floatRef.current) floatRef.current.style.transform = `translateY(${y}px)`;
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  /* Auto-advance carousel */
  useEffect(() => {
    const t = setInterval(() => setActiveMode(a => (a + 1) % GAME_MODES.length), 3500);
    return () => clearInterval(t);
  }, []);

  const fade = (d) => `lm-fade${visible ? " lm-visible" : ""} lm-d${d}`;
  const mode = GAME_MODES[activeMode];

  return (
    <div className="lm-root">
      <div className="lm-bg-grid" />
      <div className="lm-bg-glow" />

      {/* ── HERO ── */}
      <div className="lm-hero-body">
        <div className={fade(1)}>
          <div className="lm-eyebrow">Free · No signup needed</div>
          <h1 className="lm-headline">
            The ancient game,{" "}
            <span className="lm-headline-accent">reimagined</span>{" "}
            for everyone.
          </h1>
          <p className="lm-sub">
            Real-time multiplayer Ludo with AI bots, private rooms, and beautiful 3D dice.
          </p>
          <div className="lm-cta-row">
            <button className="lm-cta-primary" onClick={onPlayClick}>Play for free</button>
            <button className="lm-cta-ghost"   onClick={onRoomClick}>Create room</button>
            <button className="lm-cta-watch"   onClick={onWatchClick}>👀 Watch Live</button>
            <button className="lm-cta-nearby"  onClick={onNearbyClick}>📡 Play Nearby</button>
          </div>
          <div className="lm-stats-row">
            {STATS.map((s) => (
              <div key={s.lbl}>
                <div className="lm-stat-val">{s.val}</div>
                <div className="lm-stat-lbl">{s.lbl}</div>
              </div>
            ))}
          </div>
        </div>

        <div className={`lm-board-col ${fade(2)}`}>
          <div ref={floatRef} className="lm-board-wrap">
            <BoardSVG />
            <div className="lm-dice">🎲</div>
            {CHIPS.map((ch, i) => (
              <div
                key={i}
                className="lm-chip"
                style={{ background: ch.color, boxShadow: `0 0 8px ${ch.color}88`, ...ch.style }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* ── FEATURES ── */}
      <div className={`lm-feat-row ${fade(3)}`}>
        {FEATURES.map((f) => (
          <div key={f.title} className="lm-feat-card">
            <div className="lm-feat-icon">{f.icon}</div>
            <div className="lm-feat-title">{f.title}</div>
            <div className="lm-feat-desc">{f.desc}</div>
          </div>
        ))}
      </div>

      {/* ── GAME MODES CAROUSEL ── */}
      <div className="lm-section lm-carousel-section">
        <div className="lm-section-header">
          <span className="lm-eyebrow">Game Modes</span>
          <h2 className="lm-section-title">Choose your challenge</h2>
          <p className="lm-section-sub">Same rules, bigger boards — scale the chaos to your crew size.</p>
        </div>

        <div className="lm-carousel-body">
          {/* Board visual */}
          <div className="lm-carousel-board-wrap">
            {GAME_MODES.map((m, i) => (
              <div key={m.players} className={`lm-carousel-board-item ${i === activeMode ? "lm-cbi-active" : ""}`}>
                <MiniBoard players={m.players} colors={m.colors} />
              </div>
            ))}
          </div>

          {/* Info panel */}
          <div className="lm-carousel-info">
            {/* Fixed-height track — items are absolutely stacked here */}
            <div className="lm-carousel-info-track">
              {GAME_MODES.map((m, i) => (
                <div key={m.players} className={`lm-carousel-info-item ${i === activeMode ? "lm-cii-active" : ""}`}>
                  <span className="lm-slide-tag" style={{ background: m.colors[0] + "33", color: m.colors[0] }}>
                    {m.tag}
                  </span>
                  <div className="lm-slide-players">{m.players} Players</div>
                  <div className="lm-slide-name">{m.name}</div>
                  <p className="lm-slide-desc">{m.desc}</p>
                </div>
              ))}
            </div>

            {/* Always below the track */}
            <div className="lm-carousel-dots">
              {GAME_MODES.map((m, i) => (
                <button
                  key={i}
                  className={`lm-dot ${i === activeMode ? "lm-dot-active" : ""}`}
                  onClick={() => setActiveMode(i)}
                  style={i === activeMode ? { background: m.colors[0] } : {}}
                  aria-label={`${m.players} players`}
                />
              ))}
            </div>

            <button className="lm-cta-primary" onClick={() => onPlayWithBots(mode.players)}>
              Play {mode.players}-Player →
            </button>
          </div>
        </div>
      </div>

      {/* ── HOW TO PLAY ── */}
      <div className="lm-section lm-howto-section">
        <div className="lm-section-header">
          <span className="lm-eyebrow">Simple Rules</span>
          <h2 className="lm-section-title">How to play</h2>
          <p className="lm-section-sub">Learn in under a minute — start playing in seconds.</p>
        </div>

        <div className="lm-steps-grid">
          {STEPS.map((s) => (
            <div key={s.n} className="lm-step">
              <div className="lm-step-num">{s.n}</div>
              <div className="lm-step-icon">{s.icon}</div>
              <div className="lm-step-title">{s.title}</div>
              <p className="lm-step-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ── FOOTER ── */}
      <footer className="lm-footer">
        <div className="lm-footer-grid">

          {/* About */}
          <div className="lm-footer-col lm-footer-about-col">
            <div className="lm-footer-brand">
              <span className="lm-footer-logo">L</span>
              <span className="lm-footer-brand-name">Ludo Mania</span>
            </div>
            <p className="lm-footer-desc">
              The most thrilling digital take on the classic Ludo board game. Play with friends worldwide, challenge AI bots, and compete on the global leaderboard.
            </p>
            <div className="lm-footer-pills">
              <span className="lm-platform-pill">Web</span>
              <span className="lm-platform-pill">Android</span>
              <span className="lm-platform-pill">iOS</span>
            </div>
          </div>

          {/* Follow Us */}
          <div className="lm-footer-col">
            <h4 className="lm-footer-heading">Follow Us</h4>
            <div className="lm-social-list">
              {SOCIAL.map((s) => (
                <button key={s.name} className="lm-social-link" aria-label={s.name}>
                  <span className="lm-social-icon">{s.icon}</span>
                  <span>{s.name}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Download */}
          <div className="lm-footer-col">
            <h4 className="lm-footer-heading">Download App</h4>
            <p className="lm-footer-store-sub">Take the game anywhere with you.</p>
            <div className="lm-store-btns">
              <button className="lm-store-btn">
                <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
                <div>
                  <span className="lm-store-sub">Download on the</span>
                  <span className="lm-store-name">App Store</span>
                </div>
              </button>
              <button className="lm-store-btn">
                <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M3.18 23.76c.3.17.64.24.99.2l12.6-12.6-3.18-3.18L3.18 23.76zM20.7 10.06l-2.4-1.38-3.54 3.54 3.54 3.54 2.43-1.4c.69-.4.69-1.5-.03-1.9zM2.01 1.05C1.83 1.29 1.74 1.6 1.74 1.98v20.04c0 .38.1.7.27.93l.09.09 11.22-11.22v-.27L2.1.96l-.09.09zM13.59 12.75l-3.75 3.75L3.18.24c.35-.04.7.03 1.02.2l9.39 12.31z"/></svg>
                <div>
                  <span className="lm-store-sub">Get it on</span>
                  <span className="lm-store-name">Google Play</span>
                </div>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom strip */}
        <div className="lm-footer-strip">
          <span className="lm-footer-copy">© 2025 Ludo Mania · All rights reserved</span>
          <span className="lm-domain">www.ludomania.live</span>
        </div>
      </footer>
    </div>
  );
}
